import EUETS from "./EUETS";
import FuelEU from "./FuelEU";
import EUMRV from "./EUMRV";
import UKMRV from "./UKMRV";
import IMODCS from "./IMODCS";
import CII from "./CII";
import AdditivesUsed from "./AdditivesUsed";

const ComplianceReference = () => {
  return (
    <div className="p-6 bg-white rounded-xl shadow-sm border border-gray-200">
      <EUETS />
      <FuelEU />
      <EUMRV />
      <UKMRV />
      <IMODCS />
      <CII />
      <AdditivesUsed />
    </div>
  );
};

export default ComplianceReference;